import React, { useEffect, useState } from 'react';

import { createTheme, ThemeProvider } from '@mui/material/styles';

import websitelogo from '../../../../assets/logos/websitelogo.svg';

import CallIcon from '@mui/icons-material/Call';

import ChatIcon from '@mui/icons-material/Chat';

import ContactSupportIcon from '@mui/icons-material/ContactSupport';

import Maxprovider from '../../../../assets/logos/aboutus1.svg';

import Maxcoder from '../../../../assets/logos/aboutus2.png';

import Maxedits from '../../../../assets/logos/aboutus3.png';

import EastIcon from '@mui/icons-material/East';

import { Box, CssBaseline, Grid, Typography } from '@mui/material';

import { Link } from 'react-router-dom';

import Paper from '@mui/material/Paper';

import Button from '@mui/material/Button';

import { aboutUs } from '../../../services/api/apiManager';
import { settings as s } from '../../../services/Settings';
import './AboutUs.css';

function AboutUs() {
	const defaultTheme = createTheme();
	const [appData, setAppData] = useState([]);

	const fetchData = async () => {
		try {
			debugger;
			const response = await aboutUs();
			setAppData(response.data);
		} catch (error) {
			console.error('Error fetching app data:', error);
		}
	};
	// Call fetchData whenever needed, for example on component mount
	React.useEffect(() => {
		fetchData();
	}, []);
	return (
		<ThemeProvider theme={defaultTheme}>
			<Grid
				container
				component="main"
				className="about-page"
				sx={{
					minHeight: '100vh',
					backgroundImage: `url(${require('../../../../assets/images/Authentication-bg.webp')})`,
					backgroundRepeat: 'no-repeat',
					backgroundSize: 'cover',
					backgroundPosition: 'center',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					padding: { xs: '14px', sm: '20px', md: '28px 36px' },
				}}
			>
				<CssBaseline />
				<Grid
					container
					item
					justifyContent="center"
					className="about-shell"
					sx={{
						width: '100%',
						maxWidth: '1020px',
						borderRadius: { xs: '16px', md: '26px' },
						overflow: 'hidden',
						boxShadow: '0 28px 70px rgba(74, 95, 132, 0.22)',
						border: '1px solid rgba(255,255,255,0.72)',
						backgroundColor: 'rgba(255,255,255,0.68)',
						backdropFilter: 'blur(8px)',
					}}
				>
					<Grid
						item
						xs={false}
						sm={6}
						md={5}
						lg={5}
						xl={4.5}
						className="about-brand-panel"
						sx={{
							display: 'flex',
							flexDirection: 'column',
							justifyContent: 'space-between',
							minHeight: '560px',
							display: { sm: 'none', xs: 'none', md: 'flex' },
						}}
					>
						<Box className="about-brand-copy">
							<Typography className="about-brand-title">
								Discover MaxRemind
							</Typography>
							<Box className="about-brand-accent" />
							<Typography className="about-brand-subtitle">
								We are driven by a passion for excellence, innovation, and
								positive impact.
							</Typography>
						</Box>
						<Box className="about-brand-footer">
							<Box className="about-feature-card">
								<Box className="about-feature-icon">
									<ContactSupportIcon />
								</Box>
								<Box>
									<Typography className="about-feature-title">
										Product vision
									</Typography>
									<Typography className="about-feature-text">
										Tools designed to simplify medical billing and support
										smarter operations.
									</Typography>
								</Box>
							</Box>
							<Box className="about-feature-divider" />
							<Box className="about-feature-card">
								<Box className="about-feature-icon">
									<CallIcon />
								</Box>
								<Box>
									<Typography className="about-feature-title">
										Real support
									</Typography>
									<Typography className="about-feature-text">
										Responsive guidance from a team focused on healthcare
										workflows.
									</Typography>
								</Box>
							</Box>
						</Box>
						<Box className="about-links-row">
							<Box className="about-link-item">
								<ContactSupportIcon className="about-link-icon" />
								<Link to={'/aboutUs'} className="about-side-link">
									<Typography>About Us</Typography>
								</Link>
							</Box>
							<Box className="about-link-item">
								<CallIcon className="about-link-icon" />
								<Link to={'/contactUs'} className="about-side-link">
									<Typography>Contact Us</Typography>
								</Link>
							</Box>
						</Box>
					</Grid>
					<Grid
						component={Paper}
						square
						item
						xs={12}
						sm={12}
						md={7}
						lg={7}
						xl={7.5}
						className="about-form-panel"
						sx={{
							backgroundImage: `url(${require('../../../../assets/images/formbackground.png')})`,
							backgroundRepeat: 'no-repeat',
							backgroundSize: 'cover',
							backgroundPosition: 'center',
						}}
					>
						<Box className="about-form-wrap">
							<Box className="about-form-logo">
								<img
									src={websitelogo}
									alt="MaxCharts"
									style={{
										maxWidth: '180px',
										height: 'auto',
										objectFit: 'contain',
									}}
								/>
							</Box>
							<Typography
								component="h1"
								variant="h5"
								className="about-form-title"
							>
								About Us
							</Typography>
							<Box className="about-story-card">
								<Grid
									container
									justifyContent="center"
									alignItems="center"
								>
									<Grid item>
										<Typography
											variant="body2"
											className="about-story-text"
										>
											MaxRemind is an AI-driven IT company specializing in
											Medical Billing. We use Rule-Based Expert Systems
											technology for precise medical claims scrubbing and employ
											pattern-based NLP in our MaxAgent across MaxRemind Apps.
										</Typography>

										{/* The following paragraph will be displayed only on sm and xl screens */}
										<Typography
											variant="body2"
											className="about-story-text about-story-extra"
										>
											Our mission is complete automation in medical coding and
											billing, reducing costs and enhancing efficiency. We also
											aspire to extend AI&apos;s benefits to fields like medical
											decision-making, education, food sciences, and sports for
											the betterment of humanity.
										</Typography>
									</Grid>
								</Grid>
							</Box>
								<Grid
									container
									className="about-apps-list"
								>
									{appData.map((app, index) => (
										<Grid
											container
											key={index}
											item
											xs={12}
											direction="row"
											className="about-app-card"
										>
											<Grid
												item
												xs={12}
												md={3}
												lg={3}
												xl={3}
												sm={3}
												className="about-app-media"
											>
												<img
													key={app.AppImgName}
													src={`${s.baseUrl}/${app.AppImgPath}/${app.AppImgName}`}
													alt={app.AppImgName}
													className="about-app-image"
												/>
											</Grid>
											<Grid
												item
												xs={12}
												md={9}
												lg={9}
												xl={9}
												sm={6}
												className="about-app-content"
											>
												<Typography
													variant="h4"
													className="about-app-title"
												>
													{app?.AppName}
												</Typography>
												<Typography
													variant="body2"
													className="about-app-text"
												>
													{app?.AppDescription}
												</Typography>
												<Box className="about-app-action">
													<Button
														variant="contained"
														endIcon={<EastIcon />}
														className="about-app-button"
														onClick={() => {
															const isAppleDevice = /iPhone|iPad|iPod/i.test(
																navigator.userAgent
															);
															const storeUrl = isAppleDevice
																? app.ASurl
																: app.PSurl;
															window.open(storeUrl, '_blank');
														}}
													>
														Open
													</Button>
												</Box>
											</Grid>
										</Grid>
									))}
								</Grid>
							<Box className="about-divider-row">
								<Box className="about-divider-line" />
								<Box className="about-divider-badge">or</Box>
								<Box className="about-divider-line" />
							</Box>
							<Box className="about-login-row">
								<Typography className="about-login-text">
									Ready to sign in?
								</Typography>
								<Link to={'/'} className="about-login-link">
									<Typography>Login</Typography>
								</Link>
							</Box>
						</Box>
					</Grid>
				</Grid>
			</Grid>
		</ThemeProvider>
	);
}

export default AboutUs;
